import type { CardmarketNonSingle } from '../../../../server/src/carddetector/types'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'

export type CardMarketNonSinglesTableProps = {
  items: CardmarketNonSingle[]
}

export function CardMarketNonSinglesTable({ items }: CardMarketNonSinglesTableProps) {
  return (
    <div className="rounded-md border overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[88px]">ID</TableHead>
            <TableHead className="w-[88px]">Exp.</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Category</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className="text-center text-muted-foreground">
                No non-singles match this search.
              </TableCell>
            </TableRow>
          ) : (
            items.map((row) => (
              <TableRow key={row.idProduct}>
                <TableCell className="font-mono text-xs">{row.idProduct}</TableCell>
                <TableCell className="font-mono text-xs tabular-nums">{row.idExpansion}</TableCell>
                <TableCell className="max-w-[280px] truncate" title={row.name}>
                  {row.name}
                </TableCell>
                <TableCell className="text-muted-foreground text-sm max-w-[180px] truncate" title={row.categoryName}>
                  {row.categoryName}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  )
}
